import { render, staticRenderFns } from "./timedPush.vue?vue&type=template&id=66932efe&scoped=true&"
import script from "./timedPush.vue?vue&type=script&lang=js&"
export * from "./timedPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66932efe",
  null
  
)

export default component.exports